import React, { Component } from 'react'
import './style.scss';
import cn from 'classnames';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

export class Card extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
    }
  }
  open = () => {
    const result = !this.state.active;
    this.setState({active: result })
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.card.id != this.props.card.id){
      this.setState({active: false})
    }
  }

  setCurrent = (index) => {
    this.setState({active: false}, () => {
      setTimeout(() => {
        this.props.setCurrent(index)
      }, 100)
    })
  }

  render() {
    const { 
      card, 
      formatMessage, 
      category, 
      current, 
      count, 
      prevId, 
      downloadAnki, 
      nextId
    } = this.props;
    const { active } = this.state;
    return (
      <div className='FlashCard'>
        <div className="block-question">
          <div class="flip-card">
            <div class={cn("flip-card-inner", {active})}>
              <div class="flip-card-front" onClick={this.open}>    
                <div className="content-block">
                  {card.question_img && <div className='image'>
                    <PhotoProvider>
                      <PhotoView src={card.question_img}>
                        <img onClick={(e) => {
                          e.stopPropagation()
                        }} src={card.question_img}/>
                      </PhotoView>
                    </PhotoProvider>
                    {Boolean(card.question_img_alt) && <div className='image_alt'>{card.question_img_alt}</div>}
                  </div>}
                  <div className="block-text">
                    <div style={{width: '100%'}} dangerouslySetInnerHTML={{ __html: card.question }}/>
                  </div>
                </div>
                <div className="block-show-answer">
                  <i className="fas fa-mouse"></i> Click for answer
                </div>
              </div>
              <div class="flip-card-back">
                <div className="content-block">
                  {card.answer_img && <div className='image'>
                    <PhotoProvider>
                      <PhotoView src={card.answer_img}>
                        <img onClick={(e) => {
                          e.stopPropagation()
                        }} src={card.answer_img}/>
                      </PhotoView>
                    </PhotoProvider>
                    {Boolean(card.answer_img_alt) && <div className='image_alt'>{card.answer_img_alt}</div>}
                  </div>}
                  <div className="block-text">
                    <div style={{width: '100%'}} dangerouslySetInnerHTML={{ __html: card.answer }}/>
                  </div>
                </div>
                <div className="block-show-answer">
                  <button className="btn btn-danger" onClick={() => {
                    if(nextId > -1){
                      this.setCurrent(nextId)
                    } else {
                      this.setState({active: false})
                      this.props.onOpen()
                    }
                  }}>Don't Know</button>
                  <button className="btn btn-warning" onClick={() => {
                    if(nextId > -1){
                      this.setCurrent(nextId)
                    } else {
                      this.setState({active: false})
                      this.props.onOpen()
                    }
                  }}>Ok</button>
                  <button className="btn btn-success" onClick={() => {
                    if(nextId > -1){
                      this.setCurrent(nextId)
                    } else {
                      this.setState({active: false})
                      this.props.onOpen()
                    }
                  }}>Nailed It</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="action-card">
      
          {/* <CButton color="danger">End of Session</CButton> */}
          <div>
            <i className={cn("fas fa-chevron-left", {disabled: prevId == -1})} onClick={() => prevId > -1 ? this.setCurrent(prevId) : null}></i>
            {current}/{count}
            <i className={cn("fas fa-chevron-right", {disabled: nextId == -1})} onClick={() => nextId > -1 ? this.setCurrent(nextId) : null}></i>
          </div>
          <div style={{position: 'absolute', right: 0}}>
            {category.is_download_anki == 1 && <a onClick={(e) => {
              e.preventDefault();
              downloadAnki();
            }} className='download_anki'><i className="fa fa-download" aria-hidden="true"></i> {formatMessage('txtDownloadAnki')}</a>}
          </div>
          {/* <CButton color="info">Linked Cases</CButton> */}
        </div>
      </div>
    )
  }
}

export default Card


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardView/components/Card/Card.jsx